import { withSvgIcon } from './withSvgIcon';

export const Avatar = withSvgIcon(
  <>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path
      d="M5.74811 18.5259C7.36717 16.9621 9.57124 16 12 16C14.4288 16 16.6328 16.9621 18.2519 18.5259"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="12"
      cy="10.0141"
      r="2.5"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
